export default __webpack_public_path__ + "static/media/WaterMelon.90f11fa1.jpg";